import React, { useEffect, useState } from "react"
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Grid,
    Autocomplete,
    Typography
} from "@mui/material"
import { Controller, useForm } from "react-hook-form"
import apiUrl from '../../configs/constant';
import axios from 'axios'
import { useToast } from "../ToastProvider";
interface Props {
    open: boolean
    jenis: any
    onClose: () => void
}

export default function DialogTambahBarang({
    open,
    jenis,
    onClose
}: Props) {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const { showToast, hideToast } = useToast();
    const [listWO, setListWO] = useState<any[]>([])
    const [listAkun, setListAkun] = useState<any[]>([])
    const [listAkunBiaya, setListAkunBiaya] = useState<any[]>([])
    const [listProfitCenter, setListProfitCenter] = useState<any[]>([])

    const [valBarang, setValBarang] = useState<any>(null)
    const [listBarang, setListBarang] = useState<any[]>([])

    const today = new Date();
    const tglToday = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

    const getWo = () => {
        setListWO([])
        let url = apiUrl.apiUrl + '/production/jasa-work-order/list'

        axios
            .get(url, {
                params: {
                    awal: '2025-01-01',
                    akhir: '2999-01-01',
                    mode: 0,
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListWO(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const getBarang = () => {
        const url = apiUrl.apiUrl + '/production/jasa-work-order/list-barang'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListBarang(data)
                } else {

                    showToast(response.data.message, 'error');
                }
            })
    }

    useEffect(() => {
        if (!open) return
        reset();
        getWo();
        getBarang()
        setValue('jenis', jenis);
    }, [open])

    const {
        control,
        handleSubmit,
        formState: { errors },
        setValue,
        getValues,
        reset,
        watch
    } = useForm({
        defaultValues: {
            wo_order_id: null,
            accakun_bank_id: null,
            accakun_id: null,
            accprofitcenter_id: 3,
            tgl: tglToday,
            keterangan: null,
            total: null,
            jenis: null,
            total_biaya: null,
            sudah_dicairkan: null,
            mmbarang_id: null,
            hpp: 0,
            qty: 0
        }
    })

    const onSubmit = (payload: any) => {
        const payloadFinal = {
            ...payload,
            accakun_bank_id: payload.accakun_bank_id?.id || null,
            accakun_id: payload.accakun_id || null,
            wo_order_id: payload.wo_order_id?.id || null,
            accprofitcenter_id: payload.accprofitcenter_id?.id || null
        };

        const url = apiUrl.apiUrl + '/production/jasa-work-order/save-barang-lainnya';
        axios.post(url, payloadFinal, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(res => {
            showToast(res.data.message, 'success');
            onClose();
        });
    };

    const formatNumber = (value: string | number) => {
        if (!value) return "";

        const str = String(value);

        // split decimal
        const [int, dec] = str.replace(/\./g, "").split(",");

        const formattedInt = Number(int || 0).toLocaleString("id-ID");

        return dec !== undefined ? `${formattedInt},${dec}` : formattedInt;
    };

    const parseNumber = (value: string) => {
        return value.replace(/\./g, "");
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle sx={{ textAlign: 'center' }}>
                    TAMBAH BIAYA BARANG LAINNYA
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>

                        {/* Tanggal */}
                        <Grid item xs={12}>
                            <Controller
                                name="tgl"
                                control={control}
                                defaultValue={new Date().toISOString().slice(0, 10)}
                                rules={{ required: "Tanggal wajib diisi" }}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        type="date"
                                        label="Tanggal"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        error={!!errors.tgl}
                                        helperText={errors.tgl?.message as string}
                                    />
                                )}
                            />
                        </Grid>

                        {/* WO ORDER */}
                        <Grid item xs={12}>
                            <Controller
                                name="wo_order_id"
                                control={control}
                                rules={{ required: "WO Order wajib dipilih" }}
                                render={({ field }) => (
                                    <Autocomplete
                                        {...field}
                                        value={field.value || null}
                                        options={listWO}
                                        isOptionEqualToValue={(opt, val) => opt.id === val?.id}
                                        getOptionLabel={(o) => `${o?.kode ?? ""} | ${o?.qty ?? ""}`}
                                        filterOptions={(options, { inputValue }) => {
                                            const search = (inputValue || "").toLowerCase();

                                            return options.filter((opt) => {
                                                const kode = String(opt?.kode || "").toLowerCase();
                                                const id = String(opt?.id || "").toLowerCase();

                                                return kode.includes(search) || id.includes(search);
                                            });
                                        }}
                                        onChange={(_, val) => {
                                            field.onChange(val)
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="WO Order"
                                                error={!!errors.wo_order_id}
                                                helperText={errors.wo_order_id?.message as string}
                                            />
                                        )}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Controller
                                name="mmbarang_id"
                                control={control}
                                rules={{ required: "Barang wajib dipilih" }}
                                render={({ field }) => (
                                    <Autocomplete
                                        value={listBarang.find(item => item.id === field.value) || null}
                                        options={listBarang}
                                        isOptionEqualToValue={(opt, val) => opt.id === val?.id}
                                        getOptionLabel={(o) => o?.nama_barang ?? ""}
                                        onChange={(_, val) => {
                                            field.onChange(val?.id || null)
                                            console.log(val)
                                            setValue('accakun_id', val?.akun || null)
                                            setValue('hpp', val?.hpp || 0)
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Barang"
                                                error={!!errors.mmbarang_id}
                                                helperText={errors.mmbarang_id?.message as string}
                                            />
                                        )}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Controller
                                name="qty"
                                control={control}
                                rules={{
                                    required: "Quantity wajib diisi"
                                }}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        label="Quantity"
                                        fullWidth
                                        value={formatNumber(field.value || "0")}
                                        inputProps={{ inputMode: "numeric" }}
                                        onChange={(e) => field.onChange(parseNumber(e.target.value))}
                                        error={!!errors.qty}
                                        helperText={errors.qty?.message as string}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Controller
                                name="hpp"
                                control={control}
                                rules={{
                                    required: false
                                }}
                                render={({ field }) => (
                                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                                        HPP : {field.value || "0"}
                                    </Typography>
                                )}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography>
                                TOTAL : {watch('hpp') * watch('qty')}
                            </Typography>
                        </Grid>

                        {/* KETERANGAN */}
                        <Grid item xs={12}>
                            <Controller
                                name="keterangan"
                                control={control}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        label="Keterangan"
                                        fullWidth
                                        multiline
                                        rows={3}
                                        error={!!errors.keterangan}
                                        helperText={errors.keterangan?.message as string}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions sx={{ p: 2 }}>
                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        size="large"
                    >
                        SIMPAN
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    )
}